import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const labels = {available:"Available by advance booking only",limited:"Limited Availability",fully_booked:"Fully Booked",travel_only:"Travel Dates Only"};
export default function CompanionAvailability({ editable = false }) {
  const [status, setStatus] = useState("available");
  const [draft, setDraft] = useState("available");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let mounted = true;
    api.get("/api/companion-bookings/availability").then(({data}) => {
      const value = labels[data?.status] ? data.status : "available";
      if (mounted) { setStatus(value); setDraft(value); }
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);
  const save = async () => {
    setSaving(true);setError("");
    try {
      const {data}=await api.patch("/api/companion-bookings/availability",{status:draft},{_noOfflineQueue:true});
      setStatus(data.status);
    } catch {setError("Unable to save availability. Please try again.");}
    finally {setSaving(false);}
  };
  if (editable) return <section className="mb-6 rounded-2xl border border-white/10 bg-[#0F1118] p-4">
    <h2 className="font-semibold text-white">Public availability</h2><p className="mt-2 text-sm text-zinc-300">Controls the companion profile and enquiry page status. This does not confirm or cancel individual bookings.</p>
    <div className="mt-4 flex flex-wrap items-end gap-3"><label className="text-sm text-zinc-200">Availability status<select aria-label="Availability status" value={draft} onChange={(event)=>setDraft(event.target.value)} className="mt-2 block min-h-11 rounded-lg border border-white/15 bg-[#08090D] px-3 text-white">{Object.entries(labels).map(([key,label])=><option key={key} value={key}>{key==="available"?"Available":label}</option>)}</select></label><button type="button" onClick={save} disabled={saving || draft===status} className="min-h-11 rounded-lg bg-gradient-to-r from-[#E11D48] to-[#FF10F0] px-4 text-sm font-semibold text-white disabled:opacity-50">{saving?"Saving…":"Save availability"}</button><span role="status" className="text-sm text-zinc-300">{labels[status]}</span></div>
    {error && <p role="alert" className="mt-3 text-sm text-rose-300">{error}</p>}
  </section>;
  const color={available:"bg-emerald-300",limited:"bg-amber-300",fully_booked:"bg-rose-300",travel_only:"bg-cyan-300"}[status];
  return <p data-testid="availability-status" className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-2 text-xs text-zinc-100"><span className={`h-2 w-2 rounded-full ${color}`} />{labels[status]}</p>;
}
